import { useEffect, useState } from "react";

export type Theme = "highland" | "nautical" | "blueprint" | "eclipse";

export interface ThemeMeta {
  id: Theme;
  label: string;
  description: string;
  /** Hex preview colors: [bg, surface, primary] */
  preview: [string, string, string];
  isDark: boolean;
}

export const THEMES: ThemeMeta[] = [
  {
    id: "highland",
    label: "Highland",
    description: "Current QBA app — deep navy, clean white",
    preview: ["#EAEDF2", "#FFFFFF", "#0D2D4A"],
    isDark: false,
  },
  {
    id: "nautical",
    label: "Nautical",
    description: "Warm navy — stone-tinted surfaces",
    preview: ["#F2F0EC", "#FFFFFF", "#1C3A5C"],
    isDark: false,
  },
  {
    id: "blueprint",
    label: "Blueprint",
    description: "Your shadcn theme — bright blue, slate text",
    preview: ["#F8FAFC", "#FFFFFF", "#3B82F6"],
    isDark: false,
  },
  {
    id: "eclipse",
    label: "Eclipse",
    description: "Your shadcn dark — deep navy, blue accents",
    preview: ["#020817", "#0B1120", "#60A5FA"],
    isDark: true,
  },
];

const STORAGE_KEY = "qba-theme";
const DEFAULT_THEME: Theme = "blueprint";

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(() => {
    const stored = localStorage.getItem(STORAGE_KEY) as Theme | null;
    return THEMES.find((t) => t.id === stored) ? (stored as Theme) : DEFAULT_THEME;
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  const setTheme = (next: Theme) => {
    if (THEMES.find((t) => t.id === next)) setThemeState(next);
  };

  const meta = THEMES.find((t) => t.id === theme)!;

  return { theme, setTheme, meta, themes: THEMES };
}